// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Organisations
 */
/**
 * Identity Provider status.
 */
export type IdpStatus = (typeof IdpStatus)[keyof typeof IdpStatus];

export const IdpStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  PENDING: "PENDING",
  ERROR: "ERROR",
} as const;
